import React, { Fragment, useEffect, useRef, useState } from "react";
import { Dropdown } from "react-bootstrap";
import * as apicall from "../../../components/Apicall";
import { FaArrowRight, FaArrowLeft } from "react-icons/fa";
import { MultiSelect } from "primereact/multiselect";
import AppDropdown from "../../../components/AppDropdown/AppDropdown";
import AddService from "../../Vendor_bookings/AddService";
import Loader from "../../../components/Loader/Loader";
import { MdModeEdit } from "react-icons/md";
import SlidePanel from "../../../components/SlidePanel/SlidePanel";
import AddOfferingSlideForm from "./AddOfferingSlideForm";
import { toast } from "react-toastify";
import { STORAGE_PREFIX } from "../../../services/brandingService";
import { Form } from "react-bootstrap";

const EMPTY_OFFERING = {
  service_id: 0, service_name: "", service_type_id: 0,
  service_type_name: "", service_offering_id: 0,
  service_offering_name: "", partner_id: 0, partner_name: "",
  amount: "", time_required: 30, buffer: 0,
};

function ServiceTypesTab({ pendingService, onPendingServiceConsumed }) {
  let allServicesData = localStorage.getItem("vendorProfile");
  if (allServicesData && allServicesData !== "undefined") {
    allServicesData = JSON.parse(allServicesData);
  }
  const isClinicService = Number(allServicesData?.industry) === 1;
  const isSportsService = Number(allServicesData?.industry) === 7;

  const serviceLabelSingular = isClinicService
    ? "Specialization"
    : isSportsService
    ? "Sports"
    : "Service";

  const serviceTypeLabelSingular = isClinicService
    ? "Specialization Type"
    : isSportsService
    ? "Sports Type"
    : "Service Type";

  const columns =
    isClinicService || isSportsService
      ? ["service_name", "partner_name", "service_offering_name", "price"]
      : ["service_name", "partner_name", "service_type_name", "service_offering_name", "price"];

  const headers =
    isClinicService || isSportsService
      ? ["Sl. No", serviceLabelSingular, "Profile", serviceTypeLabelSingular, "Price", "Edit","Active"]
      : ["Sl. No", "Service Category", "Profile", "Sub Category", "Service Type", "Price", "Edit","Active"];

  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [totalPages, setTotalPages] = useState(0);
  const [activeFilter, setActiveFilter] = useState("all"); // "all" | "active" | "inactive"

  const [allServices, setAllServices] = useState([]);
  const [partners, setPartners] = useState([]);
  const [serviceData, setServiceData] = useState([]);

  // Slide panel visibility
  const [showAddServicePanel, setShowAddServicePanel] = useState(false);
  const [showAddOfferingPanel, setShowAddOfferingPanel] = useState(false);
  const [showAddProfilePanel, setShowAddProfilePanel] = useState(false);
  const [showDeletePanel, setShowDeletePanel] = useState(false);
  const [showUpdatePanel, setShowUpdatePanel] = useState(false);
  const [showInactivePanel, setShowInactivePanel] = useState(false);
  const [pendingToggle, setPendingToggle] = useState(null);
  const [confirmingInactive, setConfirmingInactive] = useState(false);

  // Profile form
  const [profle_name, setProfile_name] = useState("");
  const [profileError, setProfileError] = useState("");
  const [commission, setCommission] = useState("");
  const [addingProfile, setAddingProfile] = useState(false);

  const [addOffering, setAddOffering] = useState([{ ...EMPTY_OFFERING }]);

  const [allService, setAllService] = useState([]);
  const [allType, setAllType] = useState([]);
  const [allOffering, setAllOffering] = useState([]);
  const [allPartner, setAllPartner] = useState([]);
  const [selectedService, setSelectedService] = useState([]);
  const [selectedType, setSelectedType] = useState([]);
  const [selectedOffering, setSelectedOffering] = useState([]);
  const [selectedPartner, setSelectedPartner] = useState([]);

  const serviceRef = useRef(null);
  const typeRef = useRef(null);
  const offeringRef = useRef(null);
  const partnerRef = useRef(null);

  // Stores the pending service info so getAllServices can find the correct
  // record by name after refreshing the list (avoids relying on API response shape).
  const pendingServiceRef = useRef(null);

  const [curretOffering, setCurrentOffering] = useState({});

  useEffect(() => {
    const timer = setTimeout(() => { fetchData(); }, 500);
    return () => clearTimeout(timer);
  }, [page, limit, selectedService, selectedType, selectedOffering, selectedPartner, activeFilter]); // eslint-disable-line

  useEffect(() => { getAllServices(); }, []); // eslint-disable-line
  useEffect(() => { getServiceType(); }, [selectedService]); // eslint-disable-line
  useEffect(() => { getServiceOffering(); }, [selectedType]); // eslint-disable-line

  // When a category or sub-category was just created, store the info and refresh
  // allServices. The panel opens only AFTER getAllServices() resolves so that
  // SingleOfferingForm mounts with the correct service_id — this ensures
  // getserviceTypes() is called with the real ID on mount and the Sub Category
  // dropdown is populated correctly.
  useEffect(() => {
    if (!pendingService) return;
    pendingServiceRef.current = pendingService;
    if (onPendingServiceConsumed) onPendingServiceConsumed();
    getAllServices();
  }, [pendingService]); // eslint-disable-line

  async function fetchData() {
    try {
      setLoading(true);
      const s1 = selectedService?.map((e) => Number(e?.id));
      const s2 = selectedType?.map((e) => Number(e?.id));
      const s3 = selectedOffering?.map((e) => Number(e?.id));
      const s4 = selectedPartner?.map((e) => Number(e?.id));
      const isActiveParam =
        activeFilter === "active" ? "&&is_active=1" :
        activeFilter === "inactive" ? "&&is_active=0" : "";
      const response = await apicall.get(
        `offeringFromService?selectedService=${s1}&&selectedType=${s2}&&selectedOffering=${s3}&&selectedPartner=${s4}&&page=${page}&&limit=${limit}&&showAll=true${isActiveParam}`
      );
      if (response.success && response.data) {
        setServiceData(response.data);
        setTotalPages(response.pagination?.total_pages || 0);
      } else {
        setServiceData([]);
      }
    } catch (e) {
      console.log(e);
    } finally {
      setLoading(false);
    }
  }

  async function getAllServices() {
    try {
      setLoading(true);
      const [svc, svcType, svcOff, pts] = await Promise.all([
        apicall.get("get_ezp_service"),
        apicall.get("get_ezp_service_types"),
        apicall.get("get_ezp_service_offerings"),
        apicall.get("partners"),
      ]);
      if (svc.success && svc.data) {
        const services = svc.data;
        setAllServices(services);
        setAllService(services.map((e) => ({ id: e.id, name: e.name, is_active: e.is_active })));
        setAllType(svcType.data);
        setAllOffering(svcOff.data);

        // If a service was just created, find it by name in the fresh list and
        // open the Add Offering panel. The panel opens HERE (not earlier) so that
        // SingleOfferingForm mounts with the correct service_id, ensuring
        // getserviceTypes() fetches the right sub-categories on mount.
        if (pendingServiceRef.current) {
          const pending = pendingServiceRef.current;
          pendingServiceRef.current = null;
          const pendingName = (pending.name || "").toLowerCase().trim();
          const found = services.find(
            (s) => (s.name || "").toLowerCase().trim() === pendingName
          );
          const matched = found || services[services.length - 1]; // fallback: last added
          if (matched) {
            // Try to pre-select the exact sub category that was just added
            const allSubTypes = svcType.data || [];
            const newSubCat = pending.newSubCategoryName
              ? allSubTypes.find(
                  (t) =>
                    Number(t.service_id) === Number(matched.id) &&
                    (t.service_type_name || "").toLowerCase().trim() ===
                      (pending.newSubCategoryName || "").toLowerCase().trim()
                )
              : null;

            const withSubCategory = pending.defaultToCustom || !!matched.service_type;
            setAddOffering([{
              ...EMPTY_OFFERING,
              service_id: matched.id,
              service_name: matched.name,
              ...(withSubCategory
                ? {
                    service_type: true,
                    service_type_id: newSubCat?.service_type_id || 0,
                    service_type_name: newSubCat?.service_type_name || "Custom",
                    ...(newSubCat ? {} : { custom_type_name: "" }),
                  }
                : {}),
            }]);
            setShowAddOfferingPanel(true);
          }
        }
      }
      if (pts.success && pts.data) {
        setPartners(pts.data);
        setAllPartner(pts.data.map((e) => ({ id: e.id, name: e.partner_name, commission: e.commission })));
      }
    } catch (e) {
      console.log(e);
    } finally {
      setLoading(false);
    }
  }

  async function getServiceType() {
    try {
      let q1 = "get_ezp_service_types";
      let q2 = "get_ezp_service_offerings";
      const s1 = selectedService?.map((e) => e?.id);
      if (s1?.length > 0) { q1 += `?services=${s1}`; q2 += `?services=${s1}`; }
      const [t, o] = await Promise.all([apicall.get(q1), apicall.get(q2)]);
      setAllType(t.data);
      setAllOffering(o.data);
    } catch (e) { console.log(e); }
  }

  async function getServiceOffering() {
    try {
      let q = "get_ezp_service_offerings";
      const s1 = selectedService?.map((e) => e?.id);
      const t1 = selectedType?.map((e) => e?.id);
      let flag = true;
      if (s1?.length > 0) { q += `?services=${s1}`; flag = false; }
      if (t1?.length > 0) { q += flag ? `?service_type=${t1}` : `&&service_type=${t1}`; }
      const [o] = await Promise.all([apicall.get(q)]);
      setAllOffering(o.data);
    } catch (e) { console.log(e); }
  }

  const onHideAddService = (data) => {
    setShowAddServicePanel(false);
    if (data) {
      // Store the service name so getAllServices() can find it by name and
      // open the Add Service Type panel with service + Sub Category pre-seeded.
      pendingServiceRef.current = { name: data.name || data.service_name || "" };
      getAllServices();
    }
  };

  const resetAddOffering = () => {
    setShowAddOfferingPanel(false);
    setAddOffering([{ ...EMPTY_OFFERING }]);
  };

  const addMore = () => {
    const lastItem = addOffering.length > 0 ? addOffering[addOffering.length - 1] : {};
    setAddOffering((prev) => [
      ...prev,
      addOffering.length === 0
        ? { service_id: "", service_name: "", service_type_id: "", service_type_name: "", service_offering_id: 0, service_offering_name: "", partner_id: 0, partner_name: "", amount: "", time_required: 30, buffer: "" }
        : { ...lastItem, service_offering_id: 0, service_offering_name: "", service_offering_icon: null, amount: "", time_required: 30, buffer: "" },
    ]);
  };

  const removeOffering = (index) => setAddOffering(addOffering.filter((_, idx) => index !== idx));

  const getPageNumbers = () => {
    const pageNumbers = [];
    const totalPagesToShow = 5;
    const halfWay = Math.floor(totalPagesToShow / 2);
    if (totalPages <= totalPagesToShow) {
      for (let i = 1; i <= totalPages; i++) pageNumbers.push(i);
    } else {
      pageNumbers.push(1);
      let startPage = Math.max(2, page - halfWay);
      let endPage = Math.min(totalPages - 1, page + halfWay);
      if (page <= halfWay + 1) endPage = totalPagesToShow - 1;
      else if (page >= totalPages - halfWay) startPage = totalPages - totalPagesToShow + 2;
      if (startPage > 2) pageNumbers.push("...");
      for (let i = startPage; i <= endPage; i++) pageNumbers.push(i);
      if (endPage < totalPages - 1) pageNumbers.push("...");
      pageNumbers.push(totalPages);
    }
    return pageNumbers;
  };

  const updateData = ({ index, copyData }) => {
    const offerings = [...addOffering];
    offerings[index] = copyData;
    setAddOffering(offerings);
  };

  const updateOfferingData = (data) => setCurrentOffering(JSON.parse(JSON.stringify(data)));

  const FIELD_LABELS = {
    service_name: isClinicService ? "Specialization" : isSportsService ? "Sport" : "Service Category",
    partner_name: "Profile",
    service_type_name: isClinicService ? "Specialization Type" : "Sub Category",
    service_offering_name: isClinicService ? "Specialization Type" : isSportsService ? "Sports Type" : "Service Type",
    amount: "Price",
    time_required: "Time Required",
    buffer: "Buffer",
    custom_type_name: "Custom Sub Category",
  };

  const normStr = (val) =>
    String(val || "").toLowerCase().replace(/\s+/g, "").trim();

  const addOfferingSumbit = async () => {
    let flag = true;
    for (let i of addOffering) { if (Object.keys(i?.error || {}).length > 0) return; }
    let copy = JSON.parse(JSON.stringify(addOffering));
    const reqFields = ["service_name", "partner_name", "service_type_name", "service_offering_name", "amount", "time_required", "buffer", "custom_type_name"];
    for (let eo of copy) {
      for (let field of reqFields) {
        if (field === "custom_type_name" && eo[field]) {
          if (!eo["custom_type_name"]) { if (!eo.error) eo.error = {}; eo.error[`${field}_error`] = `Fill ${FIELD_LABELS[field]}`; flag = false; }
        } else if (field !== "custom_type_name") {
          const isEmpty = eo[field] === undefined || eo[field] === null || eo[field] === "";
          const isInvalidAmount = field === "amount" && (isEmpty || Number(eo[field]) <= 0);
          if (!isEmpty && !isInvalidAmount) continue;
          if (field === "service_type_name" && !eo["service_type"]) continue;
          if (!eo.error) eo.error = {};
          eo.error[`${field}_error`] = `Fill ${FIELD_LABELS[field]}`;
          flag = false;
        }
      }
    }

    setAddOffering(copy);
    if (!flag) return;

    // Backend duplicate check — fetch offerings for each sub category AND profile,
    // then compare. Scoped by partner_id too, since the same service type name is
    // allowed under a different profile — it only collides within the same profile.
    let dupFlag = false;
    const dupCopy = JSON.parse(JSON.stringify(copy));
    for (let eo of dupCopy) {
      if (!eo.service_offering_name || !eo.service_type_id || Number(eo.service_type_id) === 0) continue;
      try {
        const checkRes = await apicall.get(
          `get_ezp_service_offerings?service_type=${eo.service_type_id}&partner_id=${eo.partner_id}`
        );
        const existing = checkRes?.data || [];
        const isDup = existing.some(
          (o) => normStr(o.name || o.service_offering_name || "") === normStr(eo.service_offering_name)
        );
        if (isDup) {
          if (!eo.error) eo.error = {};
          eo.error["service_offering_name_error"] =
            "This service type already exists under this sub category for this profile";
          dupFlag = true;
        }
      } catch (e) {
        // proceed if check fails
      }
    }
    if (dupFlag) {
      setAddOffering(dupCopy);
      return;
    }

    try {
      const res = await apicall.post({ ...copy, storage_prefix: STORAGE_PREFIX }, "add_items");
      if (res?.success === false) {
        toast.error(res?.message || "Failed to add service type. It may already exist.");
        return;
      }
      fetchData();
      resetAddOffering();
    } catch (e) {
      toast.error("Something went wrong. Please try again.");
    }
  };

const deleteOffering = async () => {
  try {
    setLoading(true);

    const res = await apicall.post(
      {
        service_offering_id:
          curretOffering.service_offering_id,
      },
      "delete_service_offering"
    );

    if (res.success) {
      toast.success(res.message);
      fetchData();
    }
  } catch (e) {
    toast.error(
      e?.response?.data?.message ||
      "Unable to delete service type"
    );
  } finally {
    setLoading(false);
    setShowDeletePanel(false);
    setCurrentOffering({});
  }
};

  const updateOffering = async () => {
    let flag = true;
    let copy = JSON.parse(JSON.stringify(curretOffering));
    const reqFields = ["service_name", "service_type_name", "service_offering_name", "partner_name", "amount", "time_required", "buffer"];
    for (let field of reqFields) {
      if ((copy[field] === undefined || copy[field] === null || copy[field] === "") && field !== "custom_type_name") {
        if (field === "service_type_name" && !copy["service_type"]) continue;
        if (!copy.error) copy.error = {};
        copy.error[`${field}_error`] = `Fill ${FIELD_LABELS[field]}`;
        flag = false;
      }
    }
    setCurrentOffering(copy);
    if (!flag) return;
    try {
      setLoading(true);
      const res = await apicall.post({ ...curretOffering, storage_prefix: STORAGE_PREFIX }, "update_offering");
      if (res?.success === false) {
        toast.error(res?.message || "Failed to update. It may already exist.");
        return;
      }
      fetchData();
      setShowUpdatePanel(false);
      setCurrentOffering({});
    } catch (e) {
      console.log(e);
      toast.error("Something went wrong. Please try again.");
    }
    finally { setLoading(false); }
  };

  const handleOfferingToggle = async (data) => {
    const id = data.service_offering_id;
    const newStatus = data.is_active === 1 ? 0 : 1;

    if (newStatus === 0) {
      try {
        const checkRes = await apicall.post(
          { id, type: "service_offering" },
          "check_active_status"
        );
        if (checkRes.hasBookings) {
          setPendingToggle({ id, name: data.service_offering_name, count: checkRes.count });
          setShowInactivePanel(true);
          return;
        }
      } catch (e) {
        console.error(e);
      }
    }

    try {
      await apicall.post(
        { id, is_active: newStatus, type: "service_offering" },
        "active_status"
      );
      setServiceData((prev) =>
        prev.map((row) =>
          row.service_offering_id === id ? { ...row, is_active: newStatus } : row
        )
      );
    } catch (e) {
      console.error(e);
    }
  };

  const confirmInactive = async () => {
    if (!pendingToggle) return;
    try {
      setConfirmingInactive(true);
      await apicall.post(
        { id: pendingToggle.id, is_active: 0, type: "service_offering" },
        "active_status"
      );
      setServiceData((prev) =>
        prev.map((row) =>
          row.service_offering_id === pendingToggle.id ? { ...row, is_active: 0 } : row
        )
      );
    } catch (e) {
      console.error(e);
    } finally {
      setConfirmingInactive(false);
      setShowInactivePanel(false);
      setPendingToggle(null);
    }
  };

  const clearAll = () => {
    setPage(1);
    setSelectedService([]);
    setSelectedType([]);
    setSelectedOffering([]);
    setSelectedPartner([]);
    setActiveFilter("all");
  };

  const addProfile = async () => {
    if (!profle_name || profle_name.trim() === "") { setProfileError("Profile name is required"); return; }
    try {
      setAddingProfile(true);
      await apicall.post({ profile_name: profle_name, commission: commission || 0 }, "add_profile");
      setProfile_name("");
      setCommission("");
      setProfileError("");
      setShowAddProfilePanel(false);
      getAllServices();
    } catch (e) { console.log(e); }
    finally { setAddingProfile(false); }
  };

  const thStyle = {
    background: "#F9FAFB", fontWeight: 600, fontSize: "13px", color: "#374151",
    padding: "12px 16px", borderBottom: "1px solid #E5E7EB", whiteSpace: "nowrap",
  };
  const tdStyle = {
    padding: "12px 16px", fontSize: "14px", color: "#374151",
    borderBottom: "1px solid #F3F4F6", verticalAlign: "middle",
  };

  // Client-side active/inactive filter — same approach as CategoriesTab and SubcategoriesTab.
  // The backend does not support is_active param, so we always fetch showAll=true
  // and filter the current page's data here.
  const filteredServiceData = activeFilter === "all"
    ? serviceData
    : serviceData.filter((row) =>
        activeFilter === "active"
          ? Number(row.is_active) === 1
          : Number(row.is_active) === 0
      );

  return (
    <div>
      {/* Row 1: Title + Add New dropdown */}
      <div className="d-flex justify-content-between align-items-start mb-3 flex-wrap gap-2">
        <div>
          <h5 className="mb-1 fw-bold" style={{ color: "#111827" }}>{isClinicService ? " Specialization Types" : isSportsService ? "Sports Type" : "Service Types"}</h5>
          <p className="mb-0" style={{ fontSize: "13px", color: "#6B7280" }}>
            Manage all {isClinicService ? "Specialization Type " : "service offerings"}, pricing and provider assignments.
          </p>
        </div>
        <Dropdown>
          <Dropdown.Toggle className="btn-danger" variant="danger" style={{ borderRadius: "8px", fontSize: "13px", fontWeight: 600, height: "38px" }}>
            + Add New
          </Dropdown.Toggle>
          <Dropdown.Menu>
            <Dropdown.Item onClick={() => setShowAddProfilePanel(true)}>
              Add Profile
            </Dropdown.Item>
            <Dropdown.Item onClick={() => setShowAddServicePanel(true)}>
              {`Add ${serviceLabelSingular}`}
            </Dropdown.Item>
            <Dropdown.Item onClick={() => setShowAddOfferingPanel(true)}>
              {`Add ${serviceTypeLabelSingular}`}
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </div>

      {/* Row 2: Filters */}
      <div className="d-flex justify-content-between align-items-center flex-wrap mb-3">
        <div style={{ width: "100%" }} className="d-flex align-items-center gap-3 flex-wrap">
          <div style={{ width: "85%" }} className="d-flex align-items-center mb-2 gap-2 mobile-dropdown-grid">
            <MultiSelect
              value={selectedService} ref={serviceRef}
              onChange={(e) => { setPage(1); setSelectedService(e.value); }}
              options={allService} optionLabel="name" filter showClear filterDelay={400}
              placeholder={serviceLabelSingular} maxSelectedLabels={3}
              style={{ width: "100%", height: "40px" }}
            />
            {!isClinicService && !isSportsService && (
              <MultiSelect
                value={selectedType} ref={typeRef}
                onChange={(e) => { setPage(1); setSelectedType(e.value); }}
                options={allType} optionLabel="name" filter showClear filterDelay={400}
                placeholder="Sub Category" maxSelectedLabels={3}
                style={{ width: "100%", height: "40px" }}
              />
            )}
            <MultiSelect
              value={selectedOffering} ref={offeringRef}
              onChange={(e) => { setPage(1); setSelectedOffering(e.value); }}
              options={allOffering} optionLabel="name" filter showClear filterDelay={400}
              placeholder={serviceTypeLabelSingular} maxSelectedLabels={3}
              style={{ width: "100%", height: "40px" }}
            />
            <MultiSelect
              value={selectedPartner} ref={partnerRef}
              onChange={(e) => { setPage(1); setSelectedPartner(e.value); }}
              options={allPartner} optionLabel="name" filter showClear filterDelay={400}
              placeholder="Profile" maxSelectedLabels={3}
              style={{ width: "100%", height: "40px" }}
            />
          </div>
          <div className="d-flex align-items-center gap-2 flex-wrap">
            <AppDropdown
              value={activeFilter}
              options={[
                { label: "All", value: "all" },
                { label: "Active", value: "active" },
                { label: "Inactive", value: "inactive" },
              ]}
              onChange={e => { setPage(1); setActiveFilter(e.value); }}
              style={{ width: "140px", height: "40px", fontSize: "13px", flexShrink: 0 }}
            />
            <div className="clearAll" onClick={clearAll} style={{ cursor: "pointer" }}>
              Clear All
            </div>
          </div>
        </div>
      </div>

      {/* Table */}
      <div style={{ background: "#fff", borderRadius: "12px", boxShadow: "0 1px 4px rgba(0,0,0,0.08)", overflow: "hidden" }}>
        <div style={{ overflowX: "auto" }}>
          <table style={{ width: "100%", borderCollapse: "collapse", background: "#fff", fontSize: "14px" }}>
            <thead>
              <tr>{headers.map((h) => <th key={h} style={thStyle}>{h}</th>)}</tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan={headers.length} style={{ textAlign: "center", padding: "60px 0" }}>
                    <Loader style={{ width: 60, height: 30 }} />
                  </td>
                </tr>
              ) : (
                <Fragment>
                  {filteredServiceData?.length === 0 ? (
                    <tr>
                      {/* <td colSpan={8} style={{ ...tdStyle, textAlign: "center", color: "#6B7280", padding: "48px" }}>
                        No records found
                      </td> */}
                    </tr>
                  ) : (
                    filteredServiceData?.map((data, index) => (
                      <tr
                        key={data?.service_offering_id || index}
                        onMouseEnter={(e) => (e.currentTarget.style.background = "#F9FAFB")}
                        onMouseLeave={(e) => (e.currentTarget.style.background = "transparent")}
                        style={{ transition: "background 0.15s" }}
                      >
                        <td style={tdStyle}>{(page - 1) * limit + index + 1}</td>
                        {columns?.map((col, idx) => <td key={idx} style={tdStyle}>{data[col]}</td>)}
                        <td
                          style={{ ...tdStyle, cursor: "pointer", color: "#C0335A" }}
                          onClick={() => { setCurrentOffering(data); setShowUpdatePanel(true); }}
                        >
                          <MdModeEdit size={17} />
                        </td>
                        <td style={tdStyle}>
                          <Form.Check
                            type="switch"
                            checked={data.is_active === 1}
                            onChange={() => handleOfferingToggle(data)}
                            id={`offering-switch-${data.service_offering_id}`}
                          />
                        </td>
                      </tr>
                    ))
                  )}
                </Fragment>
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* Pagination */}
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "16px 4px 0", flexWrap: "wrap", gap: "12px", marginTop: "8px" }}>
        <div style={{ fontSize: "13px", color: "#6B7280" }}>Page {page} of {totalPages || 1}</div>
        <div style={{ display: "flex", alignItems: "center", gap: "8px", flexWrap: "wrap" }}>
          <select
            value={limit}
            onChange={(e) => { setPage(1); setLimit(Number(e.target.value)); }}
            style={{ border: "1px solid #D1D5DB", borderRadius: "8px", padding: "6px 10px", fontSize: "13px", color: "#374151", cursor: "pointer", background: "#fff" }}
          >
            <option value={10}>10 per page</option>
            <option value={20}>20 per page</option>
            <option value={50}>50 per page</option>
          </select>
          <button onClick={() => setPage((p) => Math.max(p - 1, 1))} disabled={page === 1} style={{ border: "1px solid #D1D5DB", borderRadius: "8px", padding: "6px 14px", fontSize: "13px", background: "#fff", color: page === 1 ? "#D1D5DB" : "#374151", cursor: page === 1 ? "not-allowed" : "pointer", display: "inline-flex", alignItems: "center", gap: "4px" }}>
            <FaArrowLeft /> Prev
          </button>
          <div style={{ display: "flex", gap: "4px" }}>
            {getPageNumbers().map((num, i) => (
              <button key={i} onClick={() => num !== "..." && setPage(num)} disabled={num === "..."} style={{ border: `1px solid ${page === num ? "#C0335A" : "#D1D5DB"}`, borderRadius: "8px", padding: "6px 12px", fontSize: "13px", background: page === num ? "#C0335A" : "#fff", color: page === num ? "#fff" : "#374151", cursor: num === "..." ? "default" : "pointer", fontWeight: page === num ? 600 : 400, minWidth: "36px", pointerEvents: num === "..." ? "none" : "auto", display: "inline-flex", alignItems: "center", justifyContent: "center" }}>
                {num}
              </button>
            ))}
          </div>
          <button onClick={() => setPage((p) => p + 1)} disabled={page === totalPages} style={{ border: "1px solid #D1D5DB", borderRadius: "8px", padding: "6px 14px", fontSize: "13px", background: "#fff", color: page === totalPages ? "#D1D5DB" : "#374151", cursor: page === totalPages ? "not-allowed" : "pointer", display: "inline-flex", alignItems: "center", gap: "4px" }}>
            Next <FaArrowRight />
          </button>
        </div>
      </div>

      {/* ── Slide Panels ── */}

      {/* Add Service */}
      <SlidePanel show={showAddServicePanel} onHide={() => onHideAddService(false)} title={`Add ${serviceLabelSingular}`}>
        <AddService onHideService={onHideAddService} />
      </SlidePanel>

      {/* Add Offering */}
      <SlidePanel
        show={showAddOfferingPanel}
        onHide={resetAddOffering}
        title={`Add ${serviceTypeLabelSingular}`}
        footer={
          <>
            <button className="btn btn-outline-secondary px-4" onClick={resetAddOffering}>Cancel</button>
            <button className="btn Button primaryBackground text-white px-4" onClick={addOfferingSumbit}>
              {loading ? <Loader style={{ width: 40, height: 20 }} /> : "Submit"}
            </button>
          </>
        }
      >
        <AddOfferingSlideForm
          allServices={allServices}
          partners={partners}
          data={addOffering}
          addMore={addMore}
          updateData={updateData}
          removeOffering={removeOffering}
          show={showAddOfferingPanel}
        />
      </SlidePanel>

      {/* Add Profile */}
      <SlidePanel
        show={showAddProfilePanel}
        onHide={() => { setShowAddProfilePanel(false); setProfileError(""); setProfile_name(""); setCommission(""); }}
        title="Add Profile"
        footer={
          <>
            <button className="btn btn-outline-secondary px-4" onClick={() => { setShowAddProfilePanel(false); setProfileError(""); setProfile_name(""); setCommission(""); }}>Cancel</button>
            <button className="btn Button primaryBackground text-white px-4" onClick={addProfile} disabled={addingProfile}>
              {addingProfile ? <Loader style={{ width: 40, height: 20 }} /> : "Submit"}
            </button>
          </>
        }
      >
        <div onKeyDown={(e) => e.key === "Enter" && addProfile()}>
          <div className="mb-3">
            <label className="form-label" style={{ fontSize: "13px", fontWeight: 500 }}>Profile Name</label>
            <input type="text" className="form-control" value={profle_name} onChange={(e) => { setProfile_name(e.target.value); setProfileError(""); }} placeholder="Enter Profile Name" />
            {profileError && <small className="text-danger">{profileError}</small>}
          </div>
          <div className="mb-3">
            <label className="form-label" style={{ fontSize: "13px", fontWeight: 500 }}>Commission %</label>
            <input type="text" className="form-control" value={commission} onChange={(e) => setCommission(e.target.value.replace(/[^0-9]/g, ""))} placeholder="Optional" />
          </div>
          
        </div>
      </SlidePanel>

      {/* Delete */}
      <SlidePanel
        show={showDeletePanel}
        onHide={() => { setShowDeletePanel(false); setCurrentOffering({}); }}
        title="Delete Offering"
      >
        <p style={{ fontSize: "15px", color: "#374151" }}>
          You are about to delete the offering{" "}
          <strong>{curretOffering?.service_name} - {curretOffering?.service_type_name} - {curretOffering?.service_offering_name}</strong>.
          This action cannot be undone. Are you sure you want to proceed?
        </p>
        <div className="d-flex gap-3 mt-4">
          <button className="btn btn-outline-secondary px-4" onClick={() => { setShowDeletePanel(false); setCurrentOffering({}); }}>Cancel</button>
          <button className="btn Button primaryBackground text-white px-4" onClick={deleteOffering}>
            {loading ? <Loader style={{ width: 40, height: 20 }} /> : "Delete"}
          </button>
        </div>
      </SlidePanel>

      {/* Update */}
      <SlidePanel
        show={showUpdatePanel}
        onHide={() => { setShowUpdatePanel(false); setCurrentOffering({}); }}
        title={`Update ${serviceLabelSingular} Information`}
        footer={
          <>
            <button className="btn btn-outline-secondary px-4" onClick={() => { setShowUpdatePanel(false); setCurrentOffering({}); }}>Cancel</button>
            <button className="btn Button primaryBackground text-white px-4" onClick={updateOffering}>
              {loading ? <Loader style={{ width: 40, height: 20 }} /> : "Update"}
            </button>
          </>
        }
      >
        <AddOfferingSlideForm
          allServices={allServices}
          partners={partners}
          isUpdate
          singleData={curretOffering}
          updateOfferingData={updateOfferingData}
          removeOffering={removeOffering}
        />
      </SlidePanel>

      {/* Inactive Confirmation SlidePanel */}
      <SlidePanel
        show={showInactivePanel}
        onHide={() => { setShowInactivePanel(false); setPendingToggle(null); }}
        title={`Inactive ${serviceTypeLabelSingular}`}
      >
        <p style={{ fontSize: "15px", color: "#374151" }}>
          There are <strong>{pendingToggle?.count}</strong> booking record(s) found for{" "}
          <strong>{pendingToggle?.name}</strong>. If you inactive this{" "}
          {serviceTypeLabelSingular.toLowerCase()}, those bookings will not be editable.
        </p>
        <div className="d-flex gap-3 mt-4">
          <button
            onClick={() => { setShowInactivePanel(false); setPendingToggle(null); }}
            className="btn btn-outline-secondary px-4"
          >
            Cancel
          </button>
          <button
            onClick={confirmInactive}
            className="btn Button primaryBackground text-white px-4"
            disabled={confirmingInactive}
          >
            {confirmingInactive ? <Loader style={{ width: 40, height: 20 }} /> : "Inactive"}
          </button>
        </div>
      </SlidePanel>
    </div>
  );
}

export default ServiceTypesTab;
